import SheetComponent from "./index";

import {Trans} from "@lingui/react/macro"
import {t} from "@lingui/core/macro"
import {checkPermissions, currencyFormat} from "../../components/permissions/functions";
import {DynamicIcon} from "lucide-react/dynamic";
import moment from "moment";
import {MobCard} from "../components/MobCard";
import ApiService from "../../services/ApiService";
import React, {Fragment} from "react";
import {API_BASE_URL, ASSET_BASE_URL, MOBCOLORS, MOBILE_PREFIX_PATH} from "../../configs/AppConfig";
import ModalLink from "../../modals/ModalLink";
import ModalUser from "../../modals/ModalUser";
import ModalContact from "../../modals/ModalContact";
import ModalCerfa from "../../modals/ModalCerfa";
import ModalEditCerfa from "../../modals/ModalEditCerfa";
import ModalCerfaGroupe from "../../modals/ModalCerfaGroupe";
import ModalChangeContact from "../../views/app-views/paiements/ModalChangeContact";
import ModalChangeOrigin from "../../views/app-views/paiements/ModalChangeOrigin";
import ModalDeletePaiement from "../../views/app-views/paiements/ModalDeletePaiement";
import ModalMessages from "../../views/app-views/messages/ModalEdit";
import {useActionSheet, withActionSheet} from "../providers/ActionSheetProvider";
import {MobEditButtonIcon} from "../components/MobEditButtonIcon";
import MobPressable from "../components/MobPressable";
import {useNavigate} from "react-router-shim";
import FicheSubmit from "../../views/app-views/form/data";
import {getStates} from "../../views/app-views/form/functions";
import {notification, Select} from "antd";
import IntlMessage from "../../components/util-components/IntlMessage";
import {getSubmitCardActions} from "../../views/mobile-views/submit/submitCardActions";
import modalLink from "../../modals/ModalLink";
import ContactFicheLoader from "../contact-fiche";

class SheetContactFiche extends SheetComponent
{
    constructor(props) {
        super(props);
    }

    onClose(){
    }

    renderContent()
    {
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()
        const contactId=payload?.params?.id
        if(!contactId){
            return null
        }

        return(
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
                <ContactFicheLoader id={contactId} embedParams={{onClose:()=>sheetContext.cancel()}}/>
            </div>
        )
    }
}

function withNavigate(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    }
}

export default withNavigate(withActionSheet(SheetContactFiche))

function Divider(){
    return(
        <div style={{width:"100%",paddingLeft:"5%",opacity:0.05}}>
            <div style={{width:"100%",borderTop:"1px solid #4A5568"}}/>
        </div>
    )
}

function DividerVertical(){
    return(
        <div style={{height:20,opacity:0.05}}>
            <div style={{height:"100%",borderLeft:"1px solid #4A5568"}}/>
        </div>
    )
}

function Section({title,children})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>

            <div style={{display:"flex",flexDirection:"row",textAlign:"center",justifyContent:"center",alignItems:"center"}}>
                <span style={{color:"#333",fontSize:18,fontWeight:"300"}}>{title}</span>
            </div>

            <div style={{display:"flex",flexDirection:"column",gap:5,marginTop:10}}>
                {children}
            </div>
        </div>
    )
}

function Item({name,value,color,children,bold})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10,padding:"0 2.5%"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"flex-start",fontSize:15}}>

                <span style={{width:"40%",fontStyle:"italic",fontWeight:"300",color:"#333",fontSize:13}}>{name}</span>

                <div style={{display:"flex",textAlign:"right",alignItems:"flex-end",maxWidth:"60vw",overflow:"hidden",textOverflow:'ellipsis',color:color || MOBCOLORS.blue.color}}>
                    {value ?(
                        <span>{value.replaceAll("undefined","").trim() || t`[Inconnu]`}</span>
                    ):(
                        <div>{children}</div>
                    )}
                </div>
            </div>

            <Divider/>
        </div>
    )
}
